import FlyScanView from './FlyScanView';

export default FlyScanView;
